<div *ngIf="isVisible">
    <div class="loader-wrapper is-active">
        <div class="loader is-loading"></div>
    </div>
</div>
